/**
 * @generated SignedSource<<a59b91a18f4084c2540ccd681954f2e0>>
 * @relayHash 22a350ef4fac32d4f6b48af65b46cca8
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 30d1fae01cc54128760f5f06b862243ae0a55af9bf55334571e770cb6e98b518

import type { ConcreteRequest, Query } from 'relay-runtime';
export type gqlJiraJsmServicesSearchServicesByIdQuery$variables = {
  ids: ReadonlyArray<string>;
  propertyKeys: ReadonlyArray<string>;
};
export type gqlJiraJsmServicesSearchServicesByIdQuery$data = {
  readonly devOpsServicesById: ReadonlyArray<{
    readonly compassId: string | null | undefined;
    readonly description: string | null | undefined;
    readonly id: string;
    readonly name: string;
    readonly properties: AGG$JSON | null | undefined;
    readonly serviceTier: {
      readonly level: number;
    } | null | undefined;
  }> | null | undefined;
};
export type gqlJiraJsmServicesSearchServicesByIdQuery = {
  response: gqlJiraJsmServicesSearchServicesByIdQuery$data;
  variables: gqlJiraJsmServicesSearchServicesByIdQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "ids"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "propertyKeys"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "ids",
    "variableName": "ids"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "id"
},
v3 = {
  "kind": "ScalarField",
  "name": "compassId"
},
v4 = {
  "kind": "ScalarField",
  "name": "name"
},
v5 = {
  "kind": "ScalarField",
  "name": "description"
},
v6 = {
  "kind": "ScalarField",
  "name": "level"
},
v7 = {
  "args": [
    {
      "kind": "Variable",
      "name": "keys",
      "variableName": "propertyKeys"
    }
  ],
  "kind": "ScalarField",
  "name": "properties"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "gqlJiraJsmServicesSearchServicesByIdQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "DevOpsService",
        "kind": "LinkedField",
        "name": "devOpsServicesById",
        "plural": true,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          {
            "concreteType": "DevOpsServiceTier",
            "kind": "LinkedField",
            "name": "serviceTier",
            "plural": false,
            "selections": [
              (v6/*: any*/)
            ]
          },
          (v7/*: any*/)
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "gqlJiraJsmServicesSearchServicesByIdQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "DevOpsService",
        "kind": "LinkedField",
        "name": "devOpsServicesById",
        "plural": true,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          {
            "concreteType": "DevOpsServiceTier",
            "kind": "LinkedField",
            "name": "serviceTier",
            "plural": false,
            "selections": [
              (v6/*: any*/),
              (v2/*: any*/)
            ]
          },
          (v7/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "id": "30d1fae01cc54128760f5f06b862243ae0a55af9bf55334571e770cb6e98b518",
    "metadata": {},
    "name": "gqlJiraJsmServicesSearchServicesByIdQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "6f936759fe89ba7568dbad62bab1ba21";

export default node;
